import { CompleteIcon } from 'shared-components';

import SectionStartTemplate from '../../../templates/sectionStart';

import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { Text } from '@chakra-ui/react';

export interface IProps {
  config: any;
}

const AllCompleteSection = (props: IProps) => {
  const { navigateToStudentDashboard } = useCustomNavigate();
  const onNext = () => navigateToStudentDashboard();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section={props.config.SectionComplete.title}
      hideProgress={true}
      onNext={onNext}
      proceedLabel={'Go to Task List'}
      onBackToTaskList={onBackToTaskList}
    >
      <CompleteIcon />

      <Text>{props.config.SectionComplete.warning}</Text>
    </SectionStartTemplate>
  );
};

export default AllCompleteSection;
